export enum UserRole {
  ADMIN = 'ADMIN',
  EDIT = 'EDIT',
  READ = 'READ'
}
